import { Pipe, PipeTransform, inject } from '@angular/core';
import { TenantDirectoryService } from './tenant-directory';

/**
 * Resolves a tenant id to a display name via {@link TenantDirectoryService}.
 * Impure so labels update when the directory cache is filled.
 * Falls back to a short id fragment when the name is unknown.
 */
@Pipe({
  name: 'tenantName',
  pure: false,
  standalone: true,
})
export class TenantNamePipe implements PipeTransform {
  private readonly directory = inject(TenantDirectoryService);

  transform(tenantId: string | null | undefined): string {
    return this.directory.nameOf(tenantId);
  }
}
